export const headerCustomStyles = {
  h1: 'tw-text-garamond-extralarge-mobile desktop:tw-text-garamond-extralarge-desktop tw-font-normal tw-mb-0',
  h2: 'tw-text-garamond-large-mobile desktop:tw-text-garamond-large-desktop tw-font-normal tw-mb-0',
};
export const subHeadersStyles = {
  h1: 'tw-text-garamond-extralarge-mobile desktop:tw-text-garamond-extralarge-desktop',
  h2: 'tw-text-garamond-large-mobile desktop:tw-text-garamond-large-desktop',
  h3: 'tw-text-garamond-medium-mobile desktop:tw-text-garamond-medium-desktop',
  h4: 'tw-text-be-base desktop:tw-text-be-lg tw-font-avenirmedium',
};

export const baseDropdownButtonStyle =
  'tw-basis-[calc(50%-8px)] tw-max-w-none [&>button]:tw-w-full [&>button]:tw-h-full [&>button]:tw-leading-4 [&>button]:tw-py-3 [&>button>span]:tw-max-w-[calc(100%-28px)] [&>button>span]:tw-overflow-hidden tw-h-[44px] tw-whitespace-nowrap [&>button>span]:tw-text-ellipsis';

export const baseButtonStyle =
  'tw-basis-[calc(50%-8px)] tw-max-w-none tw-whitespace-nowrap tw-text-ellipsis tw-overflow-hidden';
